module.exports = {
  // SERVER_URL: "https://task-endpoint.laodeveloper.com/api/"//dev 
  // SERVER_URL: "http://192.168.30.50:3800/api/work-tracking/"//IP
  // SERVER_URL: "http://192.168.30.50:3800/api/"//IP
  SERVER_URL: "https://psv-api.psvsystem.com/api/work-tracking/" // production  
}
